import { Box, Typography } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { useTranslation } from "react-i18next";
import StyledButton from "./StyledButton";

function TicketNotFound({ onClick }) {
  const { t } = useTranslation(["common"]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <SearchOffIcon
        sx={(theme) => ({
          fontSize: "100px",
          color: theme.system.colors.text.primary,
        })}
      />
      <Typography
        variant="h6"
        sx={(theme) => ({
          marginTop: "16px",
          fontSize: "16px",
          textAlign: "center",
          fontWeight: "bold",
          color: theme.system.colors.text.primary,
          fontFamily: theme.system.fonts.body,
        })}
      >
        {t("common:error.ticket_not_found")}
      </Typography>
      <StyledButton
        variant="contained"
        onClick={onClick}
        sx={{
          mt: 4,
          mb: 10,
        }}
      >
        {t("common:button.purchase_ticket")}
      </StyledButton>
    </Box>
  );
}

export default TicketNotFound;
